export class ClaimDispute { //CRE claim Auto closer and disputes
      claimNumber?: string;
      question1?: Boolean;
      question2?: Boolean;
      question3?: Boolean;
      question4?: Boolean;
      question5?: Boolean;
      question6?: Boolean;
      question7?: Boolean;
      question8?: Boolean;
      question9?: Boolean;
      question10?: Boolean;
      question11?: Boolean;
      question12?: Boolean;
      detailedFeedBack?: string;
      receiverFirstName?: string;
      receiverLastName?: string;
      receiverStreetAddress?: string;
      receiverCity?: string;
      receiverState?: string;
      receiverPostal?: string;
      receiverCountry?: string;
      receiverTelephone?: string;
      receiverEmail?: string;
}
